module.exports = __webpack_public_path__ + "static/media/cheque.67a6a23b.png";